import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { UtilService } from '@service/util/util.service';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { DATE_YMD, TruckSearchTable } from 'cargo-chief-commons';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { UntypedFormControl } from '@angular/forms';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Component({
	selector: 'app-carrier-data-feedback',
	templateUrl: './carrier-data-feedback.component.html',
	styleUrls: ['./carrier-data-feedback.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class CarrierDataFeedbackComponent implements OnInit {
	@Input() lane: TruckSearchTable = null;
	@Input() search: any = null;

	constructor(public utilService: UtilService, public dialog: MatDialog) {}

	ngOnInit() {}

	openDialog() {
		const dialogRef = this.dialog.open(CarrierDataFeedbackDialog, {
			width: '900px',
			data: {
				lane: this.lane,
				search: this.search,
			},
		});
	}
}

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'app-carrier-data-feedback-dialog',
	templateUrl: 'modal.template.html',
	styleUrls: ['./carrier-data-feedback.component.scss'],
})
export class CarrierDataFeedbackDialog implements OnInit {
	incorrectDataTypes: Array<string> = ['Incorrect Lane Info?', 'Incorrect Contact Info?'];
	incorrectLaneInfoQuestions: Array<string> = [
		'Contract lane?',
		'Only needs reverse lane?',
		'No longer runs lane.',
		'Incorrect equipment',
	];
	incorrectContactInfoQuestions: Array<string> = ['Name', 'Phone', 'Email', 'Phone & Email', 'All'];

	incorrectDataTypeSelected: string = null;
	answerSelected: string = null;

	notes: UntypedFormControl = new UntypedFormControl('');

	constructor(
		public dialogRef: MatDialogRef<CarrierDataFeedbackDialog>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public utilService: UtilService,
		private segmentWrapper: SegmentWrapperService
	) {}

	ngOnInit() {
		if (!this.utilService.isNullOrUndefined(this.data.incorrectDataType)) {
			if (this.data.incorrectDataType.toLowerCase().indexOf('lane') > -1) {
				this.incorrectDataTypeSelected = this.incorrectDataTypes[0];
			} else if (this.data.incorrectDataType.toLowerCase().indexOf('contact') > -1) {
				this.incorrectDataTypeSelected = this.incorrectDataTypes[1];
			}
		}
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	setSelection(type: string, model: string) {
		this[model] = type;
	}

	allQuestionsAnswered(): boolean {
		return (
			this.utilService.isNullOrUndefined(this.incorrectDataTypeSelected) ||
			this.utilService.isNullOrUndefined(this.answerSelected)
		);
	}

	submit() {
		let search = Object.assign({}, this.data.search);
		search.pickupDateEnd = DATE_YMD(search.pickupDateEnd);
		search.pickupDateStart = DATE_YMD(search.pickupDateStart);
		if (!search.origin && this.data?.lane?.origin) {
			search.origin = this.data.lane.origin;
		}
		if (!search.destination && this.data?.lane?.destination) {
			search.destination = this.data.lane.destination;
		}
		if (!search.trailerType && this.data?.lane?.trailerType) {
			search.trailerType = this.data.lane.trailerType;
		}
		let eventProperties = {
			lane: !this.utilService.isNullOrUndefined(this.data.lane) ? this.data.lane : null,
			incorrectDataType: this.incorrectDataTypeSelected,
			reason: this.answerSelected,
			search: search,
			notes: this.notes.value,
		};
		if (!this.utilService.isNullOrUndefined(this.data.contact)) {
			eventProperties['contact'] = this.data.contact;
		}
		this.segmentWrapper.fireSegmentEvent(
			SegmentEventsConstants.user_incorrect_carrier_info,
			eventProperties
		);
		this.closeDialog();
		this.utilService.showSnackbar(
			'We have received your report.',
			SNACKBAR.SUCCESS,
			SNACKBAR.ACTION
		);
	}
}
